import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import toast from 'react-hot-toast'

import { alertActions } from 'srcReact/Alert'
import Icon from 'srcReact/components/icons/Icon'

import styles from './styles.module.scss'

const Alert = ({ clearAlerts, text, toastProps, type, onRemoveAlert, onClose, className }) => {
  useEffect(
    () => () => {
      clearAlerts()
    },
    []
  )

  const removeAlertAction = (id) => {
    toast.remove(toastProps.id)
    if (onRemoveAlert) {
      onRemoveAlert()
    }
  }

  const color = () => {
    switch (type) {
      case 'info':
        return 'blue'
      case 'error':
        return 'red'
      case 'success':
        return 'green'
      default:
        return 'blue'
    }
  }

  return (
    <div role='alert' className={`${styles.container} ${styles[color()]} ${className}`}>
      <div className={styles.text}>{text}</div>
      {toastProps ? <div className={styles.icon2} onClick={() => removeAlertAction(toastProps.id)}>
        <Icon name='close' size='small' />
      </div> : <div className={styles.icon2} onClick={onClose}>
        <Icon name='close' size='small' />
      </div>}

    </div>
  )
}

const actionCreators = {
  clearAlerts: alertActions.clear,
}

const connectedAlert = connect(null, actionCreators)(Alert)
export { connectedAlert as Alert }
